import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core'
import { BaseComponent } from 'common/helpers'
import { SocketService } from 'common/util/module'
import { AssetMini, AssetMiniFromJSON, MediaRootMini } from 'elements-sdk'

@Component({
  selector: 'asset-thumbnail',
  templateUrl: './assetThumbnail.component.pug',
  styleUrls: ['./assetThumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetThumbnailComponent extends BaseComponent {
  @Input() asset: AssetMini
  @Input() root?: MediaRootMini
  @Input() time?: number

  isBeingScanned = false

  constructor (
    private socket: SocketService,
    private cdr: ChangeDetectorRef,
  ) {
    super()
    this.subs.add(socket.subject('media:asset-is-being-scanned').subscribe(data => {
      this.isBeingScanned = data.id === this.asset.id
      this.cdr.markForCheck()
    }))
  }

  ngOnChanges () {
    if ('default_proxy' in this.asset) {
      this.asset = AssetMiniFromJSON(this.asset)
      this.cdr.markForCheck()
    }
  }

  get extension () {
    const name = this.asset.displayName
    return name.slice(name.lastIndexOf('.') + 1)
  }
}
